export const withRecruitmentSource = (url: string, sourceCode?: string | null): string => {
  const code = sourceCode?.trim();
  if (!url || !code) return url;

  try {
    const parsed = new URL(url);
    parsed.searchParams.set("source", code);
    return parsed.toString();
  } catch {
    return url;
  }
};
